import { render, staticRenderFns } from "./StartTestButton.vue?vue&type=template&id=d7859a9c&scoped=true"
import script from "./StartTestButton.vue?vue&type=script&lang=ts"
export * from "./StartTestButton.vue?vue&type=script&lang=ts"
import style0 from "./StartTestButton.vue?vue&type=style&index=0&id=d7859a9c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7859a9c",
  null
  
)

export default component.exports